'use client'

import React from 'react'
import { useFormStatus } from 'react-dom'
import { MinimalisticMagnifer } from 'solar-icons'
import { cn } from '@/lib/utils'

import { Button, KeyChip } from '@/components/ui'

interface SearchInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

export const SearchInput = React.forwardRef<HTMLInputElement, SearchInputProps>(
  ({ className, ...props }, ref) => {
    const { pending } = useFormStatus()

    return (
      <div
        className={cn(
          'flex h-11 w-full items-center gap-1 overflow-hidden rounded-lg border border-gray-100 bg-white px-1 py-1 shadow-card ring-gray-700 focus-within:bg-white focus-within:ring-2 dark:border-gray-700 dark:bg-gray-900',
          className,
        )}
      >
        <span className="px-2">
          <MinimalisticMagnifer className="size-4" strokeWidth={1.5} />
        </span>
        <input
          type="text"
          ref={ref}
          placeholder="Search"
          className="h-full flex-grow bg-transparent text-sm font-normal placeholder-gray-400 focus-visible:outline-none"
          autoCorrect="off"
          spellCheck={false}
          {...props}
        />
      </div>
    )
  },
)

SearchInput.displayName = 'SearchInput'
